
<div class="EFProductLocation">
    <div>
        <i class="fa-regular fa-location-dot fa-fw me-1"></i>
        @if (getProductLocationName(); as name) {
            <span class="EFProductLocation-Name">{{name}} - </span>
        }
        @if (formatProductLocation(); as location) {
            <span class="EFProductLocation-Text">
                <app-pg-map-link [coordinates]="getProductCoordinates()">
                    <span [innerHTML]="location | safe:'html'"></span>
                </app-pg-map-link>
            </span>
        }
    </div>
    @if (getProductLocationDescription(); as description) {
        <div>
            <span class="EFProductLocation-Description" [innerHTML]="description | safe:'html'"></span>
        </div>
    }
</div>
                        